module.exports = __webpack_public_path__ + "img/ic_close.f8ea22c9.svg";